import { render, staticRenderFns } from "./InfoFacts.vue?vue&type=template&id=8e9fa82c&scoped=true&"
import script from "./InfoFacts.vue?vue&type=script&lang=js&"
export * from "./InfoFacts.vue?vue&type=script&lang=js&"
import style0 from "./InfoFacts.vue?vue&type=style&index=0&id=8e9fa82c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9fa82c",
  null
  
)

export default component.exports